exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".practice-team--1p-aaSrPB-4TbOPq3Gdywe {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n\n.practice-team--1p-aaSrPB-4TbOPq3Gdywe .edit,\n.practice-team--1p-aaSrPB-4TbOPq3Gdywe .delete {\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"actionsContainer": "practice-team--1p-aaSrPB-4TbOPq3Gdywe",
	"actionsContainer": "practice-team--1p-aaSrPB-4TbOPq3Gdywe"
};